import { $themeConfig } from "@themeConfig";
import app from "@/main";
export default {
  namespaced: true,
  state: {
    objectId: null,
    objectStatus: null,
    tabBooking: "61,5,17,16,6,63,62,7,31,37,38,39,40,41,42,43,44,36,35,34,25,26,27,28,29,30,32,33,8,11,9,13,10,12",
    tabQuotation: "3,4,21",
    objectType:null,
    objectView:false,
  },
  getters: {
    tabBooking(state) {
      return state.tabBooking;
    },
    tabQuotation(state) {
      return state.tabQuotation;
    },
    objectId(state) {
      return state.objectId;
    },
    objectStatus(state) {
      return state.objectStatus;
    },
    objectType(state){
      return state.objectType;
    },
    objectView(state){
      return state.objectView;
    }
  },
  mutations: {
    SET_TAB_BOOKING(state, payload) {
      state.tabBooking = payload;
    },
    SET_TAB_QUOTATION(state, payload) {
      state.tabQuotation = payload;
    },
    SET_OBJECT_ID(state, payload) {
      state.objectId = payload;
    },
    SET_OBJECT_STATUS(state, payload) {
      state.objectStatus = payload;
    },
    SET_OBJECT_TYPE(state, payload) {
      state.objectType = payload;
    },
    SET_OBJECT_VIEW(state, payload) {
      state.objectView = payload;
    },
  },
  actions: {},
};
